import { Outlet, Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

 export default function ProtectedRoute() {
  const token = Cookies.get("authToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
